class AirCanadaEventCache {
  cache: Map<string, number>
  expiryTime: number
  lastEvent: string | null = null // Keeps track of the last event added to the cache

  constructor(expiryTime: number) {
    this.cache = new Map()
    this.expiryTime = expiryTime // expiryTime in milliseconds
  }

  addEvent(eventKey: string) {
    this.cache.set(eventKey, Date.now())
    this.lastEvent = eventKey
    this.cleanup()
  }

  hasEvent(eventKey: string, isLastEventAllowed = true) {
    this.cleanup()
    const isBlockedByLastEvent =
      !isLastEventAllowed && this.lastEvent === eventKey
    return this.cache.has(eventKey) || isBlockedByLastEvent
  }

  cleanup() {
    const now = Date.now()
    const expiredKeys: any[] = []

    this.cache.forEach((timestamp, key) => {
      if (now - timestamp > this.expiryTime) {
        expiredKeys.push(key)
      }
    })

    expiredKeys.forEach((key) => {
      this.cache.delete(key)
    })
  }
}

const eventCache = new AirCanadaEventCache(10000) // 10 seconds

export default eventCache
